import React, { Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

const Dashboard = lazy(() => import('../views/app/dashboard/dashboard'));
const Profile = lazy(() => import('../views/profile/profile'));
const SignUp = lazy(() => import('../views/user/signUp'));

const Firebaselogin = lazy(() => import('../views/user/firebaselogin'));

const Login = lazy(() => import('../views/user/login'));

const HomeScreen = lazy(() => import('../views/app/home/homescreen'));


const AuthRoutes = () => 
{
    return (
        <Suspense fallback="loading...">
            <Switch>
            <Route exact path="/login" component={Login} />
                <Route path="/firebaselogin" component={Firebaselogin} />
                <Route path="/login" component={Login} />
                <Route path="/signup" component={SignUp} />
                <Redirect to="/login" />
        
      
            </Switch>
        </Suspense>
    );
}

export default AuthRoutes;
